import React from 'react'
import {request} from "../../utils/request";
import {adminUrl, frontUrl} from "../../utils/GetUrl";
import {authenticateSuccess, set_bcz_internal_token} from "../../utils/Session";
import cookie from "react-cookies";

class Login extends React.Component {

  //参数n为休眠时间，单位为毫秒:
  sleep(n) {
    const start = new Date().getTime();
    while (true) {
      if (new Date().getTime() - start > n) {
          
        break;
      }
    }
  }

  constructor(props) {
    super(props);
    //开发环境需要人为存储cookie
    // cookie.save("bcz_internal_token","d14d24b6e6d03f275b68f7f617fdfdb9");
    authenticateSuccess(true);
    // let paramStr = this.props.location.search;
    // let code_str = paramStr.substr(6,43);
    let searchParams = new URLSearchParams(window.location.href);
    let token = searchParams.get(frontUrl + "/home/login?wx_token");
    let redirect_url = searchParams.get("redirectUrl");
    // if(paramStr.indexOf("appid") != -1) {
    //     redirect_url = paramStr.substr(56, paramStr.indexOf("appid") - 56 - 1);
    // } else {
    //     redirect_url = paramStr.substr(56);
    // }
    fetch(adminUrl + "/v1/alert/user/checkLogin" , {
        method:'GET',
        credentials:"include",
        headers: {
            "bcz-internal-token":token == null ? "null" : token
        },
    })
        .then(response => response.json())
        .then(userInfo => {
            console.log("userInfo: " + userInfo["success"] + " " + userInfo["cnName"] + " " + userInfo["userId"]);
            if(userInfo["success"]) {
                console.log("set_cookie");
                set_bcz_internal_token(token);
                cookie.save("cnName", userInfo["cnName"],{path:"/"});
                cookie.save("userId", userInfo["userId"],{path:"/"});
                let request_get_param = {
                    method:'GET',
                    credentials:"include",
                    headers: {
                        "bcz-internal-token":cookie.load("bcz_internal_token") == null ? "null" : cookie.load("bcz_internal_token")
                    },
                };
                fetch(adminUrl + "/v1/checkUserExits?userId=" + userInfo["userId"], request_get_param)
                    .then(response => response.text())
                    .then(ret => {
                        if(ret == 'false') {
                            window.location.href= frontUrl + "/home/userAdd";
                        } else {
                            fetch(adminUrl + "/v1/userGroupId?userId=" + userInfo["userId"], request_get_param)
                                .then(response => response.text())
                                .then(groupId => {
                                    cookie.save("groupId", groupId,{path:"/"});
                                    fetch(adminUrl + "/v1/userGroupName?groupId=" + groupId, request_get_param)
                                        .then(response => response.text())
                                        .then(groupName => {
                                            cookie.save("groupName",groupName, {path:"/"});
                                            request(adminUrl + "/v1/userRole?userId=" + userInfo["userId"], "GET")
                                                .then(response => response.text())
                                                .then(role => {
                                                    cookie.save("role", role,{path:"/"});
                                                    window.location.href = redirect_url;
                                                })
                                        })
                                })
                        }
                    })
            }else{
                console.log('登录失败....')
            }
        })
  }

  render() {
    return ('');
  }
}

export default Login


// WEBPACK FOOTER //
// ./src/routes/Login/index.js